<template>
    <Card>
        <div class="card-body">
            <router-link class="btn btn-link" :to="{ name: 'CustomFieldCreatePage' }">
                <i class="icon-plus3 mr-2"></i>
                {{ $t('buttons.create') }}
            </router-link>
        </div>
        <FetchTable
            :handle="tableHandle"
            :url="customFieldsUrl"
            v-model:orders="table.orders"
            :columns="table.columns"
        >
            <template #card-body-actions>
                <router-link class="btn btn-link" :to="{ name: 'CustomFieldCreatePage' }">
                    <i class="icon-plus3 mr-2"></i>
                    {{ $t('buttons.create') }}
                </router-link>
            </template>
            <template #td-id="{ row }">
                <router-link :to="{ name: 'CustomFieldEditPage', params: { customFieldUuid: row.uuid } }">
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-type="{ row }">
                {{ $t(`enum.custom_field.type.${row.type}`) }}
            </template>
            <template #td-required="{ row }">
                {{ row.required ? $t('labels.yes') : $t('labels.no') }}
            </template>
            <template #td-default_value="{ row }">
                {{ formatDefaultValue(row.default_value) }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../components/new/table/tableHandle";

export default {
    name: "CustomFieldsIndexPage",
    components: {
        FetchTable,
        Card
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            table: {
                orders: [],
                columns: [
                    { key: "id", name: translate('table.titles.id'), width: "100px", type: "string", order: true },
                    { key: "type", name: translate('labels.type'), width: "100px", type: "string", order: true },
                    { key: "title", name: translate('labels.name'), width: "200px", type: "string", order: true },
                    { key: "description", name: translate('labels.description'), width: "100px", type: "string", order: false },
                    { key: "required", name: translate('labels.required'), width: "100px", type: "string", order: false },
                    { key: "default_value", name: translate('labels.default_value'), width: "100px", type: "string", order: false },
                ]
            }
        }
    },
    computed: {
        customFieldsUrl() {
            return `/projects/${this.$route.params.projectUuid}/pim/custom-fields`;
        },
    },
    methods: {
        formatDefaultValue(value) {
            if (typeof value === 'boolean') {
                return value ? translate('labels.yes') : translate('labels.no');
            }

            return value ?? '';
        }
    },
    mounted() {
        this.tableHandle.fetchRows({ models: ['product-item'] })
    }
}
</script>
